module.exports = __webpack_public_path__ + "images/7aba9b2b5ade10ecb48d9791cc0e2e6b-MSW_LineArt_PanelSwap_Xt-IQ4H_Slide5.png";